// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"897f0c25","549":"e4ea80f2","781":"c8276f91"}[chunkId] + ".chunk.js";
};